import { getAddressForChainId, type GlideWallet } from "../glideWallet";
import type { DepositOwnerProvider } from "./types";

export function createLocalWalletProvider(
  wallet: GlideWallet | null,
): DepositOwnerProvider {
  return {
    type: "local",
    getDepositOwnerAddress(chainId) {
      if (!wallet) return undefined;
      return getAddressForChainId(wallet, chainId);
    },
  };
}
